import { createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "../../../Api/Index";
import { LANDING_PAGE_URL } from "../../../Common/Constant/Index";
const FAQ = createAsyncThunk(
    "FAQ",
  
    async (payload, { rejectWithValue, dispatch, getState }) => {
  
      const details = {
        ...payload,
        withHeaders: true,
      };
  
      try {
        let url = "";
        if (details) {
          url = `${LANDING_PAGE_URL}/${payload.slug}`;
        }
        let res = await API.get(details)(url, details);
        return { FAQPage: res?.data.response.data, status: true };

   
      } catch (e) {
        return rejectWithValue(e);
      }
    }
  );

 export const DynamicImage = createAsyncThunk(
   "FAQ/getDynamicImage", // Changed the action type name
   async (payload, { rejectWithValue, dispatch, getState }) => {
     const details = {
       ...payload,
       withHeaders: true,
     };

     try {
       let url = "";
       if (details) {
         url = `${LANDING_PAGE_URL}/${payload.slug}`;
       }
       let res = await API.get(details)(url, details);
       return { DynamicImageData: res?.data.response.data, status: true }; // Changed return property name
     } catch (e) {
       return rejectWithValue(e);
     }
   }
 );

  export default FAQ;

